export const validateFinalPriceValue = (
  discount: string,
  t: (key: string) => string,
  totalPrice?: number
): string | undefined => {
  const value = Number(discount);

  if (discount === '') return undefined;

  if (value < 0) {
    return t('Amount must be greater than 0');
  }

  // if (totalPrice !== undefined && value > totalPrice)
  //   return t('Final price cannot be greater than total');

  return undefined;
};
